import { events } from "@planzone/events";
import { setRequestStateToPending } from "../../utils/setRequestStateToPending";
import { setRequestStateToSuccess } from "../../utils/setRequestStateToSuccess";
import { setRequestStateToFailure } from "../../utils/setRequestStateToFailure";
import { createStateReducer } from "../../utils/createStateReducer";
import { resetState } from "../../utils/resetState";
import { State, Selector } from "./types";
import { createSelector } from "./selector";

const initialState: State = {
  isPending: false,
  isSuccessful: false,
  isFailure: false,
};

const reduceState = resetState(
  initialState,
  createStateReducer(initialState, {
    [events.pushProjectHistoryRequested]: setRequestStateToPending,
    [events.pushProjectHistorySucceeded]: setRequestStateToSuccess,
    [events.pushProjectHistoryFailed]: setRequestStateToFailure,
  }),
  [events.changePlanzoneSucceeded],
);

export type { State, Selector };

export { reduceState, initialState, createSelector };
